// Piilottaa navigaation alas scrollatessa ja tuo takaisin esiin ylös scrollatessa, linkkaus theme.liquidiin

var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;
  
  if (window.pageYOffset <= 0) {
    document.getElementById("navbar").style.top = "50px";  
  } 
  else if (prevScrollpos > currentScrollPos) {
    document.getElementById("navbar").style.top = "5px";  
  } 
  else {
    document.getElementById("navbar").style.top = "-100px";
  }
  prevScrollpos = currentScrollPos;
}
